module.exports = __webpack_public_path__ + "img/overlay-gift.2206a03b.png";